import { render, staticRenderFns } from "./indexfooter.vue?vue&type=template&id=64fbecba&scoped=true&"
import script from "./indexfooter.vue?vue&type=script&lang=js&"
export * from "./indexfooter.vue?vue&type=script&lang=js&"
import style0 from "./indexfooter.vue?vue&type=style&index=0&id=64fbecba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbecba",
  null
  
)

export default component.exports